export const HELP_AREA_LABELS = {
  'getting-started': 'Getting Started',
  dashboard: 'Dashboard',
  jobs: 'Jobs & Schedule',
  properties: 'Properties',
  'work-orders': 'Work Orders',
  'lost-found': 'Lost and Found',
  'guest-app': 'Guest App',
  team: 'Team',
  reporting: 'Reporting',
  settings: 'Settings',
  developers: 'Developers',
  general: 'General',
};

export const getHelpAreaLabel = (area) => {
  if (!area) return HELP_AREA_LABELS.general;
  return HELP_AREA_LABELS[area] || area.replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
};

export const getHelpArticlePath = (article) => {
  if (article?.kind === 'TUTORIAL') return `/dashboard/help/tutorials/${article.slug}`;
  if (article?.kind === 'DEVELOPERS') return `/dashboard/help/developers/${article.slug}`;
  return `/dashboard/help/documentation/${article.slug}`;
};

export const getHelpSectionPath = (kind) => {
  if (kind === 'TUTORIAL') return '/dashboard/help/tutorials';
  if (kind === 'DEVELOPERS') return '/dashboard/help/developers';
  return '/dashboard/help/documentation';
};

export const getHelpSectionLabel = (kind) => {
  if (kind === 'TUTORIAL') return 'Tutorials';
  if (kind === 'DEVELOPERS') return 'Developers';
  return 'Documentation';
};
